<template>
  <v-container class="my-16 mx-auto">
    <h1>当日イベント</h1>

    <h2 class="bg-primary pa-1">
      ◆12:00-12:50
    </h2>

    <v-sheet class="ma-10 pa-3">
      <p class="text-h5">
        株式会社ロケットエンジン 「トラブル☆ウィッチーズふぁいなる！
        新キャラクター「レミエル」お披露目プレイ会」<br />声優
        るなっち☆ほしさんのサイン会
      </p>
      <p>
        「トラブル☆ウィッチーズ ふぁいなる！
        ～アマルガムの娘たち～」開発のロケットエンジンさんのステージイベントです。
      </p>
    </v-sheet>
    <h2 class="bg-primary pa-1">
      ◆13:00-13:50
    </h2>

    <v-sheet class="ma-10 pa-3">
      <p class="text-h5">プチデポット 川勝徹さん サイン会</p>
      <p>
        「グノーシア」ディレクター/プロデューサーの川勝徹さんのサイン会です。
      </p>
    </v-sheet>
    <h2 class="bg-primary pa-1">◆14:00-15:30</h2>
    <v-sheet class="ma-10 pa-3">
      <p class="text-h5">
        株式会社シャノン 飯島多紀哉さん トークショー&サイン会<br />キャラクターデザイン
        倉馬奈未さん サイン会
      </p>
      <p>
        「アパシー 鳴神学園七不思議」「アパシー
        殺人クラブ」原作・シナリオの飯島多紀哉さんとキャラクターデザイン
        倉馬奈未さんのサイン会、飯島多紀哉さんトークショー 「鳴神学園生徒総会
        出張版」です。
      </p>
    </v-sheet>
    <h2 class="bg-primary pa-1">◆16:00-17:00</h2>
    <v-sheet class="ma-10 pa-3">
      <p class="text-h5">
        株式会社RS34 「ラジルギ2」発表トークイベント&サイン会
      </p>
      <p>
        「ラジルギ」「イルベロスウォンプ」開発のRS34さんの新作発表とサイン会です。
      </p>
    </v-sheet>
    <v-divider
      :thickness="2"
      color="primary"
      class="border-opacity-50"
    ></v-divider>
    <h2 class="my-6" style="text-align: center;">◆注意事項◆</h2>
    <v-sheet class="ma-4 pa-3">
      <p>
        ※本イベントは、「イベントチケット」をご購入の方のみ参加ができます。
      </p>
      <p>※撮影、録音は禁止です。</p>
      <p>※先着順でのご案内となります。</p>
      <p>
        ※混雑緩和のため、参加整理券（無料）を別途配布する場合がございます。詳しくはイベント会場にてご確認ください。
      </p>
      <p>※出演者の事情により、やむをえず時間が変更になる可能性がございます。</p>
      <!-- <p>
        ※会場内が混雑してきた際は入れ替え制となる場合がございますので、あらかじめご了承ください。
      </p> -->
    </v-sheet>

    <!-- <ComingSoon /> -->
  </v-container>
</template>

<script>
  //import ComingSoon from "./ComingSoon.vue";

  export default {
    name: "App",
    components: {
      //  ComingSoon,
    },
  };
</script>
